import {
    FormControl,
    Input,
    Slider,
    Stack,
    Switch,
    TextField,
} from '@mui/material';
import { v4 } from 'uuid';

import { Typography } from 'components/atoms/Typography';
import { ImageConfig } from 'types/builder/componentConfig';

import { ImageSelector } from '../../editorControls/ImageSelector';

type ImageControlProps = {
    node?: ImageConfig;
    onChange: (config: ImageConfig) => void;
};

export const ImageControl = ({
    node,
    onChange,
}: ImageControlProps): JSX.Element => {
    const { srcUuid, modal = false, alt = '', scale = 100 } = node?.props || {};

    const onSrcChange = (value: string): void => {
        const img = new Image();
        img.src = `/api/builder/image/${value}/xs/3/?update_hash=${v4()}`;
        img.onload = () => {
            onChange({
                component: 'image',
                props: {
                    ...node?.props,
                    srcUuid: value,
                    update_hash: v4(),
                    aspectRatio: img.height / img.width,
                },
            });
        };
    };
    const onAltChange = (value: string): void => {
        onChange({
            component: 'image',
            props: {
                ...node?.props,
                alt: value,
            },
        });
    };
    const onModalChange = (value: boolean): void => {
        onChange({
            component: 'image',
            props: {
                ...node?.props,
                modal: value,
            },
        });
    };
    const onScaleChange = (value?: number): void => {
        onChange({
            component: 'image',
            props: {
                ...node?.props,
                scale: value,
            },
        });
    };

    return (
        <Stack spacing={2}>
            <ImageSelector
                onSelect={(img) => onSrcChange(img.uuid)}
                defaultSelectedUuid={srcUuid}
            />
            <FormControl variant="outlined">
                <TextField
                    label="Описание"
                    minRows={3}
                    multiline
                    size="small"
                    fullWidth
                    onChange={(e) => onAltChange(e.target.value)}
                    value={alt}
                />
            </FormControl>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography>Полноэкранный режим</Typography>
                <Switch
                    name="showBottomNavLink"
                    checked={modal}
                    onChange={(e, v) => onModalChange(v)}
                />
            </Stack>
            <Typography>Размер изображения</Typography>
            <Stack sx={{ px: 1 }} direction="row" spacing={1}>
                <Slider
                    value={scale}
                    max={100}
                    min={1}
                    size="small"
                    onChange={(e, v) => {
                        onScaleChange(typeof v === 'number' ? v : undefined);
                    }}
                />
                <Input
                    value={scale}
                    size="small"
                    onChange={(e) => {
                        onScaleChange(Number(e.target.value));
                    }}
                    inputProps={{
                        step: 5,
                        min: 1,
                        max: 100,
                        type: 'number',
                    }}
                />
            </Stack>
        </Stack>
    );
};
